module.exports = {
    json: require('./json'),
    JsonArray: require('./jsonarray'),
    windshaft: require('./windshaft'),
    tileJSON: require('./tilejson')
};



//////////////////
// WEBPACK FOOTER
// ./~/torque.js/lib/torque/provider/index.js
// module id = 1751
// module chunks = 6